import { Card, Typography, Divider, Tooltip, Button, Alert } from "antd";
import { InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import "./DetalleCredito.css";

const { Title, Text } = Typography;

const DetalleCredito = ({
  cuotaPagar,
  cantidadCuotas,
  periodicidad,
  tasaInteres,
  tasaEfectivaEA,
  cargosCuota,
  valorDesembolsar,
  cargos,
  screens,
}) => {
  const phone = process.env.REACT_APP_MARIA_LINE;
  const message = encodeURIComponent("¡Solicitar un crédito agro!");

  const url = `https://wa.me/${phone}?text=${message}`;
  return (
    <Card
      className="detalle-credito-card"
      style={{
        maxWidth: screens.lg ? "50%" : screens.md ? "60%" : 400,
        margin: "40px auto",
        borderRadius: 16,
        boxShadow: "0 4px 12px rgba(2, 20, 66, 0.1)",
        color: "#021442",
        padding: screens.lg ? 20 : screens.md ? 10 : 6,
      }}
    >
      <Card
        style={{
          textAlign: "center",
          backgroundColor: "#E8F8FF",
          boxShadow: "0 4px 12px rgba(2, 20, 66, 0.1)",
          borderRadius: 16,
          border: "none",
          padding: 18,
          marginBottom: 12,
        }}
      >
        <Text style={{ color: "#021442" }}>Pagarías aproximadamente</Text>
        <Title
          level={2}
          style={{ color: "#021442", margin: "8px 0", fontSize: 26 }}
        >
          ${Math.round(cuotaPagar).toLocaleString("es-CO")}
        </Title>

        <Text strong style={{ color: "#EA4E2F", fontSize: 14 }}>
          {periodicidad ? `EN CADA CUOTA ${periodicidad}` : ""}
        </Text>
      </Card>

      <Title level={4} className="detalle-titulo">
        Detalles de tu crédito
      </Title>
      <Alert
        message={
          <>
            <p>
              <strong>¡Importante!</strong>
            </p>
            <p>
              El valor de tu cuota <strong>es un valor aproximado,</strong> que
              puede variar al momento del desembolso.
            </p>
          </>
        }
        type="warning"
        showIcon
        icon={<InfoCircleOutlined />}
        className="detalle-alerta"
      />

      <div className="detalle-datos">
        <div className="detalle-fila">
          <Text strong style={{ color: "#021442", fontSize: 20 }}>
            Cuota a pagar:
          </Text>
          <Text className="detalle-valor azul" style={{ fontSize: 20 }}>
            {"$ "}
            {Math.round(cuotaPagar).toLocaleString("es-CO")}
          </Text>
        </div>
        <div className="detalle-fila">
          <Text strong style={{ color: "#021442", fontSize: 20 }}>
            Cantidad de cuotas:
          </Text>
          <Text className="detalle-valor" style={{ fontSize: 20 }}>
            {cantidadCuotas}
          </Text>
        </div>
        <div className="detalle-fila">
          <Text strong style={{ color: "#021442", fontSize: 20 }}>
            Periodicidad:
          </Text>
          <Text className="detalle-valor azul" style={{ fontSize: 20 }}>
            {periodicidad
              ? periodicidad.charAt(0).toUpperCase() +
                periodicidad.slice(1).toLowerCase()
              : ""}
          </Text>
        </div>
      </div>

      <Divider style={{ margin: "12px 0" }} />

      <Text className="detalle-seccion" style={{ color: "#EA4E2F" }}>
        Costos en la cuota:
      </Text>

      <div className="detalle-fila">
        <Text style={{ color: "#021442" }}>Tasa de interés mensual: </Text>
        <Text className="detalle-valor azul">
          {(tasaInteres * 100).toFixed(2)}%{" "}
          <Tooltip
            title={`Un interés es un costo adicional por el dinero que te prestaremos. 
    Este equivaldría al ${(tasaEfectivaEA * 100).toFixed(
      2
    )}% E.A. (Efectivo Anual)`}
            overlayInnerStyle={{
              backgroundColor: "#021442", // fondo rojo
              color: "white", // texto blanco
              padding: "10px 14px",
              fontSize: 14,
            }}
          >
            <QuestionCircleOutlined style={{ color: "#EA4E2F" }} />
          </Tooltip>
        </Text>
      </div>
      {cargosCuota.map((cuota) => {
        return (
          <div className="detalle-fila">
            <Text style={{ color: "#021442" }}>{cuota.description}: </Text>
            <Text className="detalle-valor azul">
              {"$ "}
              {Math.round(cuota.value)?.toLocaleString("es-CO")}{" "}
              <Tooltip
                title={cuota.nota}
                overlayInnerStyle={{
                  backgroundColor: "#021442",
                  color: "white",
                  padding: "10px 14px",
                  fontSize: 14,
                }}
              >
                <QuestionCircleOutlined style={{ color: "#EA4E2F" }} />
              </Tooltip>
            </Text>
          </div>
        );
      })}

      <Divider style={{ margin: "12px 0" }} />

      <Text className="detalle-seccion" style={{ color: "#EA4E2F" }}>
        Costos al desembolso:
      </Text>

      {cargos.map((cargo) => {
        return (
          <div className="detalle-fila">
            <Text style={{ color: "#021442" }}>{cargo.description}: </Text>
            <Text className="detalle-valor azul">
              {"$ "}
              {Math.round(cargo.value)?.toLocaleString("es-CO")}{" "}
              <Tooltip
                title={cargo.nota}
                overlayInnerStyle={{
                  backgroundColor: "#021442",
                  color: "white",
                  padding: "10px 14px",
                  fontSize: 14,
                }}
              >
                <QuestionCircleOutlined style={{ color: "#EA4E2F" }} />
              </Tooltip>
            </Text>
          </div>
        );
      })}

      <Divider style={{ margin: "12px 0" }} />

      <div className="detalle-fila">
        <Text strong style={{ color: "#021442", fontSize: 18 }}>
          Valor a desembolsar:
        </Text>
        <Text className="detalle-valor azul" strong style={{ fontSize: 18 }}>
          {"$ "}
          {Math.round(valorDesembolsar)?.toLocaleString("es-CO")}
        </Text>
      </div>

      <Button
        type="default"
        className="detalle-boton"
        style={{
          backgroundColor: "#EA4E2F",
          borderRadius: "24px",
          fontWeight: 600,
          alignContent: "center",
        }}
        onClick={() => window.open(url, "_blank")}
        block
      >
        ¡Quiero mi crédito!
      </Button>
    </Card>
  );
};

export default DetalleCredito;
